import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t,getLanguage} from 'react-switch-lang';
import {
  getAllRiskCauses,
  createRiskCause,
  deleteRiskCause,
  updateRiskCauses,
} from '../../../services/riskCausesService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './RiskCauses.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
const RiskCauses = () => {
  const [riskCauses, setRiskCauses] = useState([]);
  const [query, setQuery] = useState();
  const addButton = useRef();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllRiskCauses();
        setRiskCauses(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('riskCauses.name'),
      editable: true,
      placeholder: t('riskCauses.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('riskCauses.nameEn'),
      editable: true,
      placeholder: t('riskCauses.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updateRiskCauses(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('riskCauses.message.updateSuccess', {
            entity: t('riskCauses.riskCause'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.riskCausesExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.riskCausesExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createRiskCause(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('riskCauses.message.addSuccess', {
            entity: t('riskCauses.riskCause'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.riskCausesExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.riskCausesExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteRiskCauses'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),

        confirmButtonText: t('common.delete').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deleteRiskCause(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('riskCauses.message.deleteSuccess', {
                  entity: t('riskCauses.riskCause'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {}
        },
      });
    });
  };

  return (
    <div className="users administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('riskCauses.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('riskCauses.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/risk-causes"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        queryParamName="name.contains"
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default RiskCauses;
